import { getMenuItem } from "../../../services";
import { Icon } from "../../icons";
import { Link } from "react-router-dom";

const MenuItem = (props) => {
  const { menu, feature = "tenken", permission = true, setOpenModal } = props;
  const menuItem = getMenuItem(menu, feature);
  const linkColor = permission ? "group-hover:text-[#5293fa]" : "";
  const style =
    feature === "tenken"
      ? "pl-[44px] lg:pl-14 xl:pl-14 2xl:pl-16 space-x-1"
      : feature === "master" && menu !== "inspection-template-master-top"
      ? "pl-[60px] lg:pl-6 xl:pl-12 space-x-2"
      : feature === "master" && menu === "inspection-template-master-top"
      ? "pl-6 lg:pl-0 xl:pl-2 2xl:pl-1"
      : feature === "inspection-templates"
      ? "inpection-master-item space-x-2"
      : feature === "approval-settings"
      ? "approval-master-item space-x-2"
      : "pl-6 xl:pl-2 2xl:pl-10 space-x-2";

  const renderTitle = (title) => {
    const parts = title.split("マスタ");
    let before = parts[0];
    let after = "マスタ";
    if (feature !== "master") {
      if (menu === "machine-master-group-update" || feature === "inspection-templates") {
        after += parts[1];
      } else {
        before += "マスタ";
        after = parts[1];
      }
    }
    return (
      <>
        {before}
        <span className="break-all inline-block">{after}</span>
      </>
    );
  };
  return (
    <div className="group bg-white border border-[#e0e0e0] rounded-[8px] lg:px-4 px-1 py-[24px] max-w-[360px] relative">
      {!permission && (
        <div
          role="button"
          className="absolute inset-0 bg-tenken-gray-500 opacity-50 cursor-pointer rounded-[8px]"
          onClick={() => setOpenModal(true)}
        ></div>
      )}
      <div className="flex flex-col items-center">
        <Link to={menuItem.link} className="w-full">
          <div className={`flex items-center mb-1 ${style}`}>
            <Icon
              name={menuItem.icon}
              className="xl:w-20 xl:h-20 w-[60px] h-[60px] object-cover"
            />
            <h3
              className={`xl:text-[18px] lg:text-[17px] text-base font-bold ${linkColor}`}
            >
              {feature === "tenken"
                ? menuItem.title
                : renderTitle(menuItem.title)}
            </h3>
          </div>
          <p className={`text-center text-[14px] lg:text-[15px] xl:text-[16px] ${linkColor}`}>
            {menuItem.description}
          </p>
        </Link>
      </div>
    </div>
  );
};

export default MenuItem;
